import AdminPagamenti from "./AdminPagamenti";

export default AdminPagamenti;
